import { apiCall } from "./service";
import {
  BASE_URL,
  URL_BUDGETS,
  URL_PROJECT_BUDGETS,
  URL_PROGRAM_BUDGETS,
  URL_BUDGET,
  URL_CREATE_BUDGET,
  URL_UPDATE_BUDGET,
  URL_DELETE_BUDGET,
  URL_BUDGET_FLAG,
  URL_PORTFOLIO,
} from "./URL";

export const api = {
  sortBudgetsRequest(params) {
    if (params.parent === "Project")
      return apiCall.pagination({
        url: `${URL_PROJECT_BUDGETS}${params.id}/CostItems?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Program")
      return apiCall.pagination({
        url: `${URL_PROGRAM_BUDGETS}${params.id}/CostItems?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Budget")
      return apiCall.pagination({
        url: `${URL_BUDGETS}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Portfolio")
      return apiCall.pagination({
        url: `${URL_PORTFOLIO}/${params.id}/CostItems?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
  },

  getBudgetsRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;
    console.log("Parent type:", parent);
    switch (parent) {
      
      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/CostItems`;
        if (search)
          paginationParams.searchTerm = search;
        break;

      case "Program":
        url = `${BASE_URL}Programs/${id}/budgets`;
        break;

      case "Project":
        url = `${BASE_URL}Projects/${id}/budgets`;
        break;

      default:
        url = `${BASE_URL}CostItems`;
        if (search)
          paginationParams.searchTerm = search;
        break;
    }

    

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  fetchSingleBudgetRequest(id) {
    return apiCall.get({ url: `${URL_BUDGET}${id}` });
  },

  getBudgetRequest(params) {
    return apiCall.get({
      url: `${URL_BUDGET}${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  createBudgetRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_BUDGET}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  updateBudgetRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_BUDGET}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  deleteBudgetRequest(params) {
    // return apiCall.delete({url: `${URL_DELETE_BUDGET}${params.id}`, isAuthToken: true, params });
  },

  updateBudgetFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_BUDGET_FLAG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  getBudgetExport(params) {
    const queryParams = Object.entries(params)
      .filter(([_, value]) => value !== null && value !== undefined) // Remove null/undefined values
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const url = `${URL_BUDGET}Export${queryParams ? `?${queryParams}` : ""}`;
    return apiCall.getFile({
      url,
      headers: {
        Accept:
          "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Content-Type": "blob",
      },
      responseType: "arraybuffer",
    });
  },
};

export default api;
